var Backbone, EmailFormIntlBaseDateInputView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

Backbone.$ = $;

EmailFormIntlBaseDateInputView = (function(superClass) {
  extend(EmailFormIntlBaseDateInputView, superClass);

  function EmailFormIntlBaseDateInputView() {
    return EmailFormIntlBaseDateInputView.__super__.constructor.apply(this, arguments);
  }

  EmailFormIntlBaseDateInputView.prototype.initialize = function(options) {
    this.options = options || {};
    this.I18nScope = 'modules.support';
    this.isInputFieldEmpty = true;
    this.maxLength = 250;
    this.base_template = this.options.template;
    this.model = this.options.model;
    this.isFlexibleStepThree = this.options.isFlexibleStepThree;
    this.label = this.model.label;
    this.isInputCompulsory = this.model.required === true || this.model.required === "true";
    return this.show_template = {};
  };

  EmailFormIntlBaseDateInputView.prototype.render = function() {
    this.$el.html(toHtml(this.base_template, this.toHash()));
    return this.$el.find(this.elementID).datepicker();
  };

  EmailFormIntlBaseDateInputView.prototype.toHash = function() {
    var hash, ref;
    hash = {
      stepThreeType: this.isFlexibleStepThree ? 'flexibleStepThree' : 'defaultStepThree',
      label: this.label,
      required: this.isInputCompulsory,
      maxLength: this.maxLength,
      counter: this.model.counter,
      options: this.dropdownOptions,
      show_dropdown: ((ref = this.dropdownOptions) != null ? ref.length : void 0) > 0
    };
    return _.extend(this.show_template, hash);
  };

  EmailFormIntlBaseDateInputView.prototype.getInputHtmlElement = function() {
    return this.$el.find(this.elementID);
  };

  EmailFormIntlBaseDateInputView.prototype.isInputGiven = function() {
    return this.getInputHtmlElement().val().trim().length > 0;
  };

  EmailFormIntlBaseDateInputView.prototype.isInputValid = function() {
    return true;
  };

  EmailFormIntlBaseDateInputView.prototype.validateEmailForm = function() {
    if (this.isInputCompulsory && ((this.isInputFieldEmpty && this.isInputGiven()) || !(this.isInputFieldEmpty || this.isInputGiven()))) {
      this.isInputFieldEmpty = !this.isInputGiven();
      return this.options.validateEmailForm();
    }
  };

  EmailFormIntlBaseDateInputView.prototype.populateInput = function(data) {
    var inputData;
    if (this.isInputGiven()) {
      inputData = this.readInput();
      return data.description += "\n\n " + this.label + " : " + inputData;
    }
  };

  EmailFormIntlBaseDateInputView.prototype.deleteKeyDownHandler = function(e) {
    if (e.keyCode === 8) {
      e.stopPropagation();
      e.preventDefault();
      return false;
    }
  };

  return EmailFormIntlBaseDateInputView;

})(Backbone.View);

module.exports = EmailFormIntlBaseDateInputView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3MvZW1haWxfZm9ybS9JTlRML2Jhc2VfZGF0ZV9pbnB1dF92aWV3LmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL3JtdXJ1Z2FuL25hcGlzdHJhbm8vYnVpbGQvMTUwMTc4MjAxNjMwNi01OTQzNS9wcm9kdWN0aW9uLTIwMTcuMDguMDNfMTcuMzYvc3VwcG9ydF9hcHAvbW9kdWxlcy9zdXBwb3J0L2Zyb250ZW5kL3ZpZXdzL2VtYWlsX2Zvcm0vSU5UTC9iYXNlX2RhdGVfaW5wdXRfdmlldy5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQSx3Q0FBQTtFQUFBOzs7QUFBQSxRQUFBLEdBQVcsT0FBQSxDQUFRLFVBQVI7O0FBQ1gsUUFBUSxDQUFDLENBQVQsR0FBYTs7QUFFUDs7Ozs7OzsyQ0FFSixVQUFBLEdBQVksU0FBQyxPQUFEO0lBQ1YsSUFBQyxDQUFBLE9BQUQsR0FBVyxPQUFBLElBQVc7SUFDdEIsSUFBQyxDQUFBLFNBQUQsR0FBYTtJQUNiLElBQUMsQ0FBQSxpQkFBRCxHQUFxQjtJQUNyQixJQUFDLENBQUEsU0FBRCxHQUFhO0lBQ2IsSUFBQyxDQUFBLGFBQUQsR0FBaUIsSUFBQyxDQUFBLE9BQU8sQ0FBQztJQUMxQixJQUFDLENBQUEsS0FBRCxHQUFTLElBQUMsQ0FBQSxPQUFPLENBQUM7SUFDbEIsSUFBQyxDQUFBLG1CQUFELEdBQXVCLElBQUMsQ0FBQSxPQUFPLENBQUM7SUFDaEMsSUFBQyxDQUFBLEtBQUQsR0FBUyxJQUFDLENBQUEsS0FBSyxDQUFDO0lBQ2hCLElBQUMsQ0FBQSxpQkFBRCxHQUFxQixJQUFDLENBQUEsS0FBSyxDQUFDLFFBQVAsS0FBbUIsSUFBbkIsSUFBMkIsSUFBQyxDQUFBLEtBQUssQ0FBQyxRQUFQLEtBQW1CO1dBQ25FLElBQUMsQ0FBQSxhQUFELEdBQWlCO0VBVlA7OzJDQVlaLE1BQUEsR0FBUSxTQUFBO0lBQ04sSUFBQyxDQUFBLEdBQUcsQ0FBQyxJQUFMLENBQVUsTUFBQSxDQUFPLElBQUMsQ0FBQSxhQUFSLEVBQXVCLElBQUMsQ0FBQSxNQUFELENBQUEsQ0FBdkIsQ0FBVjtXQUNBLElBQUMsQ0FBQSxHQUFHLENBQUMsSUFBTCxDQUFVLElBQUMsQ0FBQSxTQUFYLENBQXFCLENBQUMsVUFBdEIsQ0FBQTtFQUZNOzsyQ0FJUixNQUFBLEdBQVEsU0FBQTtBQUNOLFFBQUE7SUFBQSxJQUFBLEdBQ0U7TUFBQSxhQUFBLEVBQWtCLElBQUMsQ0FBQSxtQkFBSixHQUE2QixtQkFBN0IsR0FBc0Qsa0JBQXJFO01BQ0EsS0FBQSxFQUFPLElBQUMsQ0FBQSxLQURSO01BRUEsUUFBQSxFQUFVLElBQUMsQ0FBQSxpQkFGWDtNQUdBLFNBQUEsRUFBVyxJQUFDLENBQUEsU0FIWjtNQUlBLE9BQUEsRUFBUyxJQUFDLENBQUEsS0FBSyxDQUFDLE9BSmhCO01BS0EsT0FBQSxFQUFTLElBQUMsQ0FBQSxlQUxWO01BTUEsYUFBQSw2Q0FBK0IsQ0FBRSxnQkFBbEIsR0FBMkIsQ0FOMUM7O1dBT0YsQ0FBQyxDQUFDLE1BQUYsQ0FBUyxJQUFDLENBQUEsYUFBVixFQUF5QixJQUF6QjtFQVRNOzsyQ0FXUixtQkFBQSxHQUFxQixTQUFBO1dBQ25CLElBQUMsQ0FBQSxHQUFHLENBQUMsSUFBTCxDQUFVLElBQUMsQ0FBQSxTQUFYO0VBRG1COzsyQ0FHckIsWUFBQSxHQUFjLFNBQUE7V0FDWixJQUFDLENBQUEsbUJBQUQsQ0FBQSxDQUFzQixDQUFDLEdBQXZCLENBQUEsQ0FBNEIsQ0FBQyxJQUE3QixDQUFBLENBQW1DLENBQUMsTUFBcEMsR0FBNkM7RUFEakM7OzJDQUdkLFlBQUEsR0FBYyxTQUFBO1dBQ1o7RUFEWTs7MkNBR2QsaUJBQUEsR0FBbUIsU0FBQTtJQUNqQixJQUFHLElBQUMsQ0FBQSxpQkFBRCxJQUFzQixDQUFDLENBQUMsSUFBQyxDQUFBLGlCQUFELElBQXNCLElBQUMsQ0FBQSxZQUFELENBQUEsQ0FBdkIsQ0FBQSxJQUEyQyxDQUFDLENBQUMsSUFBQyxDQUFBLGlCQUFELElBQXNCLElBQUMsQ0FBQSxZQUFELENBQUEsQ0FBdkIsQ0FBN0MsQ0FBekI7TUFDRSxJQUFDLENBQUEsaUJBQUQsR0FBcUIsQ0FBQyxJQUFDLENBQUEsWUFBRCxDQUFBO2FBQ3RCLElBQUMsQ0FBQSxPQUFPLENBQUMsaUJBQVQsQ0FBQSxFQUZGOztFQURpQjs7MkNBS25CLGFBQUEsR0FBZSxTQUFDLElBQUQ7QUFDYixRQUFBO0lBQUEsSUFBRyxJQUFDLENBQUEsWUFBRCxDQUFBLENBQUg7TUFDRSxTQUFBLEdBQVksSUFBQyxDQUFBLFNBQUQsQ0FBQTthQUNaLElBQUksQ0FBQyxXQUFMLElBQW9CLE9BQUEsR0FBUSxJQUFDLENBQUEsS0FBVCxHQUFlLEtBQWYsR0FBb0IsVUFGMUM7O0VBRGE7OzJDQUtmLG9CQUFBLEdBQXNCLFNBQUMsQ0FBRDtJQUNwQixJQUFHLENBQUMsQ0FBQyxPQUFGLEtBQWEsQ0FBaEI7TUFDRSxDQUFDLENBQUMsZUFBRixDQUFBO01BQ0EsQ0FBQyxDQUFDLGNBQUYsQ0FBQTtBQUNBLGFBQU8sTUFIVDs7RUFEb0I7Ozs7R0FoRHFCLFFBQVEsQ0FBQzs7QUFzRHRELE1BQU0sQ0FBQyxPQUFQLEdBQWlCIn0=
